<div data-testid="analysis-countries">
  <app-coverage-tab-header
    titleKey="project.steps.rfi.invitationList.analysis.countriesTitle"
    [titleParams]="titleParams()"
  >
    <span class="text-muted-color text-sm">
      {{ 'project.steps.rfi.invitationList.analysis.sortedByEmployees' | transloco }}
    </span>
  </app-coverage-tab-header>

  <div class="bg-second-level rounded-md p-4">
    <div class="my-2.5 flex items-center gap-3 font-bold">
      <span class="w-12">
        {{ 'project.steps.rfi.invitationList.analysis.column.country' | transloco }}
      </span>
      <span class="flex-1">
        {{ 'project.steps.rfi.invitationList.analysis.column.employeeShare' | transloco }}
      </span>
      <span class="text-muted-color w-28 text-right">
        {{ 'project.steps.rfi.invitationList.analysis.employeesUnit' | transloco }}
      </span>
      <span class="w-24 text-right">
        {{ 'project.steps.rfi.invitationList.analysis.column.coverage' | transloco }}*
      </span>
    </div>
    @for (country of view().countries; track country.isoCode) {
      <div class="my-2.5 flex items-center gap-3" data-testid="analysis-country-row">
        <b class="w-12" [title]="country.name">{{ country.isoCode }}</b>
        <app-rfi-coverage-bar class="flex-1" [percent]="country.employeeShare" />
        <span class="text-muted-color w-28 text-right">
          {{ country.employees | appNumber: '1.0-0' }}
          {{ 'project.steps.rfi.invitationList.analysis.employeesUnit' | transloco }}
        </span>
        <span class="w-24 text-right" [ngClass]="country.coverageClass">
          @if (country.coverage === null) {
            –
          } @else {
            {{ country.coverage | appNumber: '1.2-2' }} %
          }
        </span>
      </div>
    }
    <p class="text-muted-color mt-3 text-sm">
      {{ 'project.steps.rfi.invitationList.analysis.countriesFootnote' | transloco }}
    </p>
  </div>
</div>
